import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import YouTube from 'react-youtube';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width:100%;
  height:800px;

  @media (max-width: 768px) {
    text-align: center;
    justify-content: center;
    align-items: center;
    height:auto;
  }
`;

const Title = styled.div`
  font-size: 40px;
  display: flex;
  color: #385963;
  font-weight: 600;
  margin-bottom: 20px;
  justify-content: left;

  @media (max-width: 768px) {
    font-size: 25px;
  
  }
`;

const Description = styled.div`
  font-size: 20px;
  margin-bottom: 50px;
  color: #91abb3;
  display: flex;
  justify-content: left;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;


const IframeWrapper = styled.div`
  width: 100%;
  height: 800px;
  // position: relative;
  align-items:center;
  border-radius: 10px;
  overflow: hidden;
  // margin: 0 auto;

  /* override react-youtube internal wrapper */
  .react-youtube-container > div {
    width: 100% !important;
    height: 100% !important;
    padding-bottom: 0 !important;
  }

  iframe {
    width: 100% !important;
    height: 100% !important;
  }

  @media (max-width: 768px) {
    width:80vw;
    height: 250px;
    place-self:center;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    margin:0px 80px;
  }
`;


// const IframeWrapper = styled.div`
//   width: 60vw;
//   height: 800px;
//   position: relative;
//   border-radius: 10px;
//   overflow: hidden;
//   margin: 0 auto;

 
//   iframe {
//     width: 100% !important;
//     height: 100% !important;
//   }

//   @media (max-width: 768px) {
//     width: 100vw;
//     height: 250px;
//   }
// `;



const ErrorText = styled.p`
  font-size: 16px;
  color: red;
  text-align: center;
  margin-top: 10px;
`;

const VideoPLayer = ({ video }) => {
  const { i18n } = useTranslation();

  const extractVideoId = (url) => {
    try {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#\&\?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    } catch {
      return null;
    }
  };

  const videoId = extractVideoId(video);

  if (!videoId) {
    return <ErrorText>Invalid video link</ErrorText>;
  }

  const opts = {
    width: '100%',
    height: '100%',
    playerVars: {
      autoplay: 0,
    },
  };

  return (
    <Container>
      <Title>{i18n.t('video')}</Title>
      {/* <Description>{i18n.t('videoDescription')}</Description> */}
      {/* <IframeWrapper>
        <YouTube className="react-youtube-container" videoId={videoId} opts={opts} />
      </IframeWrapper> */}
     
     <IframeWrapper>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </IframeWrapper>
    

    </Container>
  );
};

export default VideoPLayer;
